import owd from 'owd/owd';
// import 'infinity/infinity.js';
// import Clusterize from 'clusterize.js';

export default class LongList extends owd.Component {
	init() {
        this.allItems = [];
        this.$trailer = this.$element.find('[data-long-list-trailer]');
        this.$element.children().not('[data-long-list-trailer]').each((index, item) => this.allItems.push($(item)));
        this.visibleItems = this.allItems.map(item => item);
        this.scrollTop = this.dom.$window.scrollTop();
        this.additionalRowsCount = 1;

        this.updateHeight();
        this.calculateListSize();
        this.requestUpdate();
        this.bind();

        this.$element.data('longList.api', this);
    }
    
    clearItems() {
        this.allItems = [];
        this.rowsNeeded = null;
        this.firstRow = null;
        this.lastRow = null;

        this.calculateListSize();
        this.requestUpdate();
    }

    appendItem($item) {
        this.appendItems([
            $item
        ]);
    }
    
    appendItems(items) {
        items.forEach(($item) => {
            this.allItems.push($item);
        });

        if (!this.elHeight || !this.visibleItems.length) {
            if (!this.visibleItems.length) {
                this.visibleItems = this.allItems.map(item => item);
                this.$element.append(this.visibleItems);
            }
        }
    
        this.updateHeight();
        this.forceReflow = true;

        this.calculateListSize();
        this.requestUpdate();
    }

	bind() {
        this.on('resize layout-reflow', this.dom.$window, () => {
            this.updateHeight();
            this.calculateListSize();
            this.requestUpdate();
        });
        
        this.on('scroll', this.dom.$window, () => {
            this.scrollTop = this.dom.$window.scrollTop();
            this.requestUpdate();
        });
    }

    getExampleElement() {
        if (this.visibleItems.length) {
            return this.visibleItems[0];
        } else if (this.$trailer) {
            return this.$trailer;
        }

        return null;
    }

    updateHeight() {
        this.elHeight = this.getExampleElement() ? this.getExampleElement().height() : 0;
        this.elWidth = this.getExampleElement() ? this.getExampleElement().width() : 0;
        this.vpHeight = this.dom.$window.height();
        this.vpWidth = this.$element.width();
        this.top = this.$element.offset().top;
        this.cols = Math.floor(this.vpWidth / this.elWidth);
        this.rows = Math.ceil(this.allItems.length / this.cols);
        this.additionalRowsCount = Math.max(1, Math.round(Math.floor(this.vpHeight / this.elHeight) / 2));
    }

    calculateListSize() {
        this.listHeight = this.elHeight * Math.ceil(this.allItems.length / this.cols);
    }

    requestUpdate() {
        const rowsNeeded = Math.ceil(this.vpHeight / this.elHeight) + this.additionalRowsCount*2;
        const firstRow = Math.max(0, Math.floor((this.scrollTop - this.top) / this.elHeight) - this.additionalRowsCount);
        const lastRow = firstRow + rowsNeeded;

        if (this.rowsNeeded != rowsNeeded || this.firstRow != firstRow || this.lastRow != lastRow || this.forceReflow) {
            this.rowsNeeded = rowsNeeded;
            this.firstRow = firstRow;
            this.lastRow = lastRow;
            this.forceReflow = false;

            if (!this.af) {
                this.af = requestAnimationFrame(() => {
                    this.af = null;
                    this.update();
                });
            }
        }

    }

    update() {
        const newVisibleItems = [];
        const prepend = [];
        const append = [];
        let begun = false;

        for (let i = this.firstInRow(this.firstRow); i < this.lastInRow(this.lastRow); i++) {
            newVisibleItems.push(this.allItems[i]);

            if (this.visibleItems.indexOf(this.allItems[i]) < 0) {
                if (!begun) {
                    prepend.push(this.allItems[i]);
                } else {
                    append.push(this.allItems[i]);
                }
            } else {
                begun = true;
            }
        }

        this.$element.prepend(prepend);
        this.$element.append(append);

        for (let i in this.visibleItems) {
            if (newVisibleItems.indexOf(this.visibleItems[i]) < 0) {
                if (this.visibleItems[i]) {
                    this.visibleItems[i].detach();
                }
            }
        }

        if (this.$trailer.length && this.lastRow == this.rows && this.visibleItems.length % this.cols) {
            this.$trailer.detach();
            this.$element.append(this.$trailer);
        } else if (this.$trailer.length) {
            this.$trailer.detach();
        }

        this.visibleItems = newVisibleItems;

        this.$element.css({
            paddingTop: this.firstRow * this.elHeight,
            paddingBottom: (this.rows - this.lastRow) * this.elHeight
        });

        setTimeout(() => {
            this.dom.$window.trigger('layout-reflow');
        });
    }

    firstInRow(row) {
        return Math.max(0, this.cols * (row));
    }
    
    lastInRow(row) {
        return Math.min(this.allItems.length, this.cols * row);
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('long-list', {
	component: LongList
});
